module.exports = __webpack_public_path__ + "img/stars.8dcd5c1a.svg";